import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from 'react';
const AudioRtcPlayer: React.FC<{
  url: string | null;
  ref?: any;
  autoPlay?: boolean;
}> = forwardRef((props, ref) => {
  const { url, autoPlay } = props;

  const audioPlayerRef = useRef<any>(null);
  const audioElementRef = useRef<HTMLVideoElement>(null);
  useImperativeHandle(ref, () => {
    return {
      handlePlay,
      handlePause,
    };
  }, [url]);

  const handlePlay = () => {
    if (!url) {
      return;
    }
    if (audioPlayerRef.current) {
      audioPlayerRef.current?.close();
    }
    audioPlayerRef.current = new (window as any).SrsRtcPlayerAsync();
    if ($('#audio-rtc-player')) {
      $('#audio-rtc-player').prop('srcObject', audioPlayerRef.current?.stream);
    }
    audioPlayerRef.current
      .play(url)
      .then((res: any) => {})
      .catch((e: any) => {
        audioPlayerRef.current && audioPlayerRef.current.close();
        const timer = setTimeout(() => {
          clearTimeout(timer);
          handlePlay();
        }, 1000);
      });
  };

  const handlePause = () => {
    audioPlayerRef.current && audioPlayerRef.current.close();
    audioPlayerRef.current = null;
  };

  useEffect(() => {
    return () => {
      handlePause();
    };
  }, []);
  useEffect(() => {
    if (autoPlay && url) {
      handlePlay();
    }
  }, [autoPlay, url]);

  return (
    <video
      id='audio-rtc-player'
      ref={audioElementRef}
      autoPlay
      style={{
        position: 'absolute',
        visibility: 'hidden',
        bottom: 20,
        zIndex: -1,
      }}
    ></video>
  );
});

export default AudioRtcPlayer;
